import * as SelectPrimitive from "@radix-ui/react-select";
import { ComponentProps } from "react";
import {
  Select,
  SelectContent,
  SelectGroup,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "@/shared/components/ui/select";
import t from "@/lang/lang";
import { useListBranchQuery } from "@/services/backend/company/api/branch";
import { RefreshCw } from "lucide-react";
import { RTKQueryErrorAlert } from "@/shared/components/errors/rtk-query-error-alert";

export function BranchSelectFrom({
  branchIds,
  ...props
}: ComponentProps<typeof SelectPrimitive.Root> & {
  branchIds: string[];
}) {
  const { data, isLoading, error } = useListBranchQuery({});
  const branches = data?.branches.filter((b) => branchIds.includes(b.id)) ?? [];

  return (
    <Select {...props}>
      <SelectTrigger className="w-full">
        <SelectValue placeholder={t("Niederlassung auswählen")} />
      </SelectTrigger>
      <SelectContent>
        <SelectGroup>
          {isLoading && (
            <SelectItem value="loading" disabled>
              <RefreshCw className="size-4" />
              <span>{t("Lade Niederlassungen")}</span>
            </SelectItem>
          )}
          {error && (
            <SelectItem value="error" disabled>
              <RTKQueryErrorAlert error={error} />
            </SelectItem>
          )}
          {branches.map((branch) => (
            <SelectItem value={branch.id} key={branch.id}>
              <span>{branch.name}</span>
            </SelectItem>
          ))}
        </SelectGroup>
      </SelectContent>
    </Select>
  );
}
